import { createFileRoute } from "@tanstack/react-router";
import { SEOPage } from "@/components/site/SEOPage";
import { Check, ShieldCheck, Zap } from "lucide-react";

const ArticlePage = () => {
  const breadcrumbs = [
    { label: "Elite", href: "/" },
    { label: "Blog", href: "/blog" },
    { label: "Como Escolher um Painel IPTV Pós Pago", href: "/blog/como-escolher-painel-iptv-pos-pago" }
  ];

  const sections = [
    {
      title: "Checklist para Escolher o Servidor Certo",
      type: "grid" as const,
      content: (
        <>
          {[
            { t: "Estabilidade de Sinal", d: "Peça um teste em horário de pico (domingo à noite ou jogos importantes).", i: <Zap /> },
            { t: "Transparência de Faturamento", d: "Certifique-se de que o painel mostra o consumo real em tempo real.", i: <ShieldCheck /> },
            { t: "Qualidade dos Apps", d: "O servidor oferece apps próprios e estáveis como One X e P2 PRO?", i: <Check /> }
          ].map((item, i) => (
            <div key={i} className="p-8 rounded-3xl bg-white/[0.02] border border-white/5">
              <div className="w-12 h-12 rounded-2xl bg-electric/10 text-electric flex items-center justify-center mb-6">
                {item.i}
              </div>
              <h3 className="text-xl font-bold mb-3">{item.t}</h3>
              <p className="text-muted-foreground text-sm">{item.d}</p>
            </div>
          ))}
        </>
      )
    }
  ];

  return (
    <SEOPage
      category="Como Escolher um Painel IPTV Pós Pago"
      title="Como Escolher um Painel IPTV Pós Pago em 2026"
      subtitle="Não caia em armadilhas. Aprenda a identificar uma estrutura de elite que vai valorizar sua marca de revenda."
      heroImage="https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&q=80&w=1200"
      introParagraphs={[
        "Com a popularização do modelo pós-pago, surgiram muitos servidores amadores que prometem estabilidade mas não entregam. Como revendedor, sua reputação está em jogo.",
        "Neste guia prático, listamos os critérios técnicos e comerciais que você deve exigir de qualquer fornecedor de painel pós-pago antes de migrar sua base."
      ]}
      benefits={[
        { title: "Segurança de Marca", description: "Trabalhe com um servidor que não cai e valorize seu nome no mercado." },
        { title: "Tecnologia CDN", description: "Exija servidores com distribuição global para garantir zero travamentos." }
      ]}
      howItWorks={[
        { title: "Testagem", description: "Realize testes rigorosos de performance e suporte." },
        { title: "Validação", description: "Verifique a compatibilidade com os principais apps do mercado." }
      ]}
      diferenciais={[
        { title: "Apps Homologados", description: "Garantia de funcionamento perfeito no One X e P2 PRO." }
      ]}
      faq={[
        { question: "O que é mais importante: preço ou estabilidade?", answer: "Sempre a estabilidade. Um cliente que não tem quedas de sinal renova todos os meses, garantindo seu lucro a longo prazo." }
      ]}
      breadcrumbs={breadcrumbs}
      sections={sections}
      ctaTitle="🚀 Quer Conhecer a Nossa Infraestrutura?"
      ctaDescription="Veja por que somos a escolha número 1 dos revendedores profissionais."
      ctaButtonText="Conhecer Infraestrutura"
    />
  );
};

export const Route = createFileRoute("/blog/como-escolher-painel-iptv-pos-pago")({
  head: () => ({
    meta: [
      { title: "Como Escolher um Painel IPTV Pós Pago - Guia de Elite | P2 PRO" },
      { name: "description", content: "Aprenda a escolher o melhor painel IPTV pós-pago. Critérios técnicos, análise de estabilidade e suporte para sua revenda." }
    ],
  }),
  component: ArticlePage,
});
